<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";

</script>

<Card>
    <CardBody>
        <div class="mb-4 h1 card-title">LJP Data Sample</div>
        <div>
          <!-- <p class="card-text"> -->
            <pre class="card-text">
&lbrace;
  'fact': '피고인은 2022. 11. 14. 혈중알콜농도 0.123%의 술에 취한 상태로 승용차를 운전하였다.',
  'laws_service': '도로교통법 제148조의2 제3항 제2호,도로교통법 제44조 제1항',
  'laws_service_id': 7
&rbrace;
           </pre>
        </div>
      </CardBody>
</Card>